import {useState, useEffect} from "react";
import {useSelector} from "../../../shared-services/redux-tiny";
import topLayerState from "../../../shared-services/globalState/topLayerState";
import angularIntegration from "../../../angular-integration";

const delay = 2000;

const useFreeDeliveryBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [freeDeliveryBannerName, setFreeDeliveryBannerName] = useState("");
  const {currentUser} = useSelector(state => state.session);
  const {pageCode} = useSelector(state => state.router);
  const [forceRenderOnCatalogChange, setForceRenderOnCatalogChange] = useState(false);
  const {emptyAboveHeaderDrawer} = topLayerState();
  const {$on} = angularIntegration;

  $on("triggerFreeDeliveryBannerRender", () => {
    setForceRenderOnCatalogChange(prev => !prev);
  });

  useEffect(() => {
    let showCondition = false;
    if (pageCode === "catalog" || pageCode === "search_results" || pageCode === "pdp") {
      showCondition = localStorage.getItem("free_delivery_banner_catalog_pdp_shown") !== "true" &&
        (currentUser && !currentUser?.id);
    } else if (pageCode === "cart") {
      showCondition = !currentUser?.id || currentUser?.complete_order_count === 0;
    }

    const timeout = setTimeout(() => {
      setShowBanner(showCondition);
      if (showCondition) {
        if (pageCode === "catalog" || pageCode === "search_results" || pageCode === "pdp") {
          setFreeDeliveryBannerName("FreeDeliveryBanner:CatalogPdp");
        } else if (pageCode === "cart") {
          setFreeDeliveryBannerName("FreeDeliveryBanner:Cart");
        }
      }
      localStorage.setItem("free_delivery_banner_catalog_pdp_shown", "true");
    }, delay);

    return () => {
      setShowBanner(false);
      clearTimeout(timeout);
    };
  }, [pageCode, currentUser, forceRenderOnCatalogChange]);

  const closeBannerDesktop = () => {
    setShowBanner(false);
  };
  const closeBannerMobile = () => {
    emptyAboveHeaderDrawer({name: freeDeliveryBannerName});
  };
  return {
    showBanner,
    freeDeliveryBannerName,
    closeBannerMobile,
    closeBannerDesktop
  };
};

export default useFreeDeliveryBanner;
